/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DeleteSSOVideoViewModel } from "../types/DeleteSSOVideoViewModel.ts";
import { eViewPortSchema } from "./eViewPortSchema.ts";

export const deleteSSOVideoViewModelSchema = z.object({
  cultureInfo: z.string().min(1),
  viewPort: z
    .lazy(() => eViewPortSchema)
    .describe("1 = Desktop | 2 = Mobile | "),
}) as unknown as ToZod<DeleteSSOVideoViewModel>;
